import { render } from "./QAView.vue?vue&type=template&id=310265d4&ts=true"
import script from "./QAView.vue?vue&type=script&lang=ts"
export * from "./QAView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__